import Colors from "@src/constants/Colors";

interface UpArrowIconProps {
  strokeColor: string | undefined;
}

const UpArrowIcon = ({ strokeColor }: UpArrowIconProps) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 12.5L10.25 7.5L5.25 12.5"
        stroke={strokeColor || Colors.neutral_gray_500}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UpArrowIcon;
